import { observer } from "mobx-react-lite";
import FooterStore from "../../../../old/Store/FooterStore";
import { ReactComponent as FooterIco } from "../../../../old/Assets/footer.svg";
import React, { useEffect, useMemo, useState } from "react";
import * as ST from "./styled";
import { SocialNetworkUrl } from "../../../../old/Types/FooterType";
import { formatUrl } from "../../../../old/Utils/Others/formatUrl";

const errText = "";

const CLOUD = !!process.env.REACT_APP_CLOUD_URL;

const filterCb = (url: SocialNetworkUrl) => url.isVisible;

const Footer = observer(() => {
	const data = FooterStore.dataFooter;
	const [modalShow, setModalShow] = useState<boolean>();
	useEffect(() => {
		if (modalShow === undefined) {
			setModalShow(true);
		}
	}, [modalShow]);

	const visibleSocialNetworkUrls = useMemo(
		() => data?.socialNetworkUrls.filter(filterCb),
		[data?.socialNetworkUrls]
	);

	const visibleFooterUrls = useMemo(
		() => data?.footerUrls.filter(filterCb),
		[data?.footerUrls]
	);

	// console.log("Footer - footerData:", JSON.parse(JSON.stringify(data)));
	return data && modalShow ? (
		<>
			<ST.Image>
				<FooterIco />
			</ST.Image>
			<ST.Footer>
				<ST.Title>PreventAge®</ST.Title>
				<ST.SubTitle dangerouslySetInnerHTML={{ __html: data?.text || errText }} />
				<ST.Wrapper>
					<ST.ListLinks>
						<ST.ListItemLinks>
							<ST.Address
								target="_blank"
								href={`https://yandex.ru/maps/?text=${
									data?.address || errText
								}`}
							>
								{data?.address || errText}
							</ST.Address>
						</ST.ListItemLinks>
						<ST.ListItemLinks>
							<ST.Phone href={`tel:${data?.phone || errText}`}>
								{data?.phone || errText}
								<ST.PhoneDescription>(Бесплатно по России)</ST.PhoneDescription>
							</ST.Phone>
						</ST.ListItemLinks>
						<ST.ListItemLinks>
							<ST.WebSite
								target="_blank"
								href={`mailto:${data?.email || errText}`}
							>
								{data?.email || errText}
							</ST.WebSite>
						</ST.ListItemLinks>
						<ST.ListItemLinks>
							<ST.ListNetworks>
								{visibleSocialNetworkUrls?.map((socialNetwork) => (
									<ST.ListItemNetworks
										key={`socialNetworkUrls-item-${socialNetwork.id}`}
										onClick={() => window.open(socialNetwork.url, "_blank")}
									>
										<img
											alt={socialNetwork.name}
											src={formatUrl(socialNetwork.iconSocialNetwork, CLOUD)}
										/>
									</ST.ListItemNetworks>
								))}
							</ST.ListNetworks>
						</ST.ListItemLinks>
					</ST.ListLinks>
					<ST.ListLinksTwo>
						{visibleFooterUrls?.map(
							(item, index) =>
								index <= 4 && (
									<ST.ListItemLinks
										key={`footer-item1-${item.id}`}
										onClick={() => window.open(item.url, "_blank")}
									>
										<ST.Link>{item.name}</ST.Link>
									</ST.ListItemLinks>
								)
						)}
					</ST.ListLinksTwo>
					<ST.ListLinksTwo>
						{visibleFooterUrls?.map(
							(item, index) =>
								index >= 5 &&
								index <= 8 && (
									<ST.ListItemLinks
										key={`footer-item1-${item.id}`}
										onClick={() => window.open(item.url, "_blank")}
									>
										<ST.Link>{item.name}</ST.Link>
									</ST.ListItemLinks>
								)
						)}
					</ST.ListLinksTwo>
					<ST.ListLinksTwo>
						{visibleFooterUrls?.map(
							(item, index) =>
								index >= 9 && (
									<ST.ListItemLinks
										key={`footer-item1-${item.id}`}
										onClick={() => window.open(item.url, "_blank")}
									>
										<ST.Link>{item.name}</ST.Link>
									</ST.ListItemLinks>
								)
						)}
						{data?.logoDeveloper && (
							<ST.ListItemLogoDeveloper
								onClick={() => window.open(data?.urlDeveloper, "_blank")}
							>
								<img
									alt={"Логотип разработчика"}
									src={formatUrl(data?.logoDeveloper, CLOUD)}
								/>
							</ST.ListItemLogoDeveloper>
						)}
					</ST.ListLinksTwo>
				</ST.Wrapper>
				<ST.FooterText>
					* — Некоторые организации признаны экстремистскими на территории РФ
				</ST.FooterText>
			</ST.Footer>
		</>
	) : (
		<></>
	);
});

export default Footer;
